import { CommunicationChannel } from "@tm/utils"

export const dashboardTemplateSixChannel: CommunicationChannel = []
